import { Field } from 'formik'
import React from 'react'
import InputContainer from '../InputContainer'
import InputLabel from '../InputLabel'

function RadioButtons({ radioField, ...rest }) {

    const {options, name, prompt} = radioField;

    return (
        <InputContainer>
            <InputLabel text={prompt} htmlfor={name} />
            
            <Field name={name} >
                {({ field }) => {
                    return options.map(option => {
                        return (
                            <span key={option.key} className=' flex gap-3'>
                                <input
                                    type='radio'
                                    id={option.value}
                                    {...field}
                                    {...rest}
                                    value={option.value}
                                    checked={field.value === option.value}
                                />
                                <label htmlFor={option.value}>{option.key}</label>
                            </span>
                        )
                    })
                }}
            </Field>
        </InputContainer>
    )
}

export default RadioButtons